import { render, staticRenderFns } from "./LoadWhenVisible.vue?vue&type=template&id=2dca82d4&"
import script from "./LoadWhenVisible.vue?vue&type=script&lang=ts&"
export * from "./LoadWhenVisible.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports